module.exports = __webpack_public_path__ + "img/hr-wooden-particle-23.f7c0f035.png";